module.exports = __webpack_public_path__ + "static/media/icon_close.5b65bec9.svg";